import React from 'react';
import RestaurantsCard from './RestaurantsCard';

const RestaurantsList = ({ restaurants = [] }) => {
  if (restaurants.length === 0) {
    return <div className="restaurants-list">No restaurants to display.</div>;
  }

  return (
    <div className="restaurants-list grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
      {restaurants.map((r, i) => {
        // pick the string or the .current field
        const slugKey = typeof r.slug === 'string'
          ? r.slug
          : r.slug?.current;

        return (
          <RestaurantsCard
            key={slugKey || `restaurant-${i}`}
            restaurant={r}
          />
        );
      })}
    </div>
  );
};

export default RestaurantsList;